export default __webpack_public_path__ + "static/hpv-box@2x-3e116ff2ae053d38ad84145b0f47015c.png";